import fb_logo from './icons8-facebook-48.png'
import twitter_logo from './icons8-twitter-48.png'
import github_logo from './icons8-github-48.png'
import { Link } from 'react-router-dom'

//This contains the entire footer information such as links, copyright, about, etc.
function Footer(props) {
    // Copyright logo
    const copyrightData = {
        copyRight: 'Copyright \u00A9 2022'
    }

    return (
        <footer className='footer'>
            <ul className='footer-list'>
                {props.onLoad !== 'support' ?
                <div>
                    <div className='footer-column'>
                        <p id='copyright'>{copyrightData.copyRight}</p>
                    </div>
                    <div className='footer-column'>
                        <Link to='/about' id='about' style={{color:'lightblue'}}>about</Link>
                    </div>
                    <div className='footer-column'>
                        <Link to='/support' id='support' style={{color:'lightblue'}}>support</Link>
                    </div>
                    <ul className='social-links-column'>
                        <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                            <img src={fb_logo} alt= "fb_logo" />
                        </a>
                        <a href="https://twitter.com/mic_lasborne/" target="_blank" rel="noreferrer">
                            <img src={twitter_logo} alt= "twitter_logo" />
                        </a>
                        <a href="https://www.github.com/lasborne/" target="_blank" rel="noreferrer">
                            <img src={github_logo} alt= "github_logo" />
                        </a>
                    </ul>
                </div>
                    :
                <div> 
                    <div className='footer-column'>
                        <p id='copyright'>{copyrightData.copyRight}</p>
                    </div>
                    <div className='footer-column'>
                        <Link to='/' id='about' style={{color:'lightblue'}}>Back to HomePage</Link>
                    </div>
                    <ul className='social-links-column'>
                        <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                            <img src={fb_logo} alt= "fb_logo" />
                        </a>
                        <a href="https://twitter.com/mic_lasborne/" target="_blank" rel="noreferrer">
                            <img src={twitter_logo} alt= "twitter_logo" />
                        </a>
                        <a href="https://www.github.com/lasborne/" target="_blank" rel="noreferrer">
                            <img src={github_logo} alt= "github_logo" />
                        </a>
                    </ul>
                </div>
                }
            </ul>
        </footer>
    )
}

export default Footer